import Api from '../../library/api';
import { LOGIN_SUCCESS } from '../login/login-actions';

export const LOGOUT = 'LOGOUT';
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const VIEW_AS_BUSINESS = 'VIEW_AS_BUSINESS';
export const VIEW_AS_ADMIN = 'VIEW_AS_ADMIN';

export function viewAsAdmin() {
  return {
    type: VIEW_AS_ADMIN
  }
}

export function viewAsBusiness(business_id) {
  return {
    type: VIEW_AS_BUSINESS,
    payload: {
      business_id: business_id
    }
  }
}

export function logout() {
  return dispatch => {
    Api.post('p/log-out')
      .then(() => dispatch({type: LOGOUT}))
  }
}

export function checkSession(wasLoggedIn) {
  return dispatch => {
    Api.post('p/logged-in')
      .then(resp => {

        if (wasLoggedIn && resp.loggedIn === false) return dispatch({type: SESSION_EXPIRED});
        if (resp.loggedIn === false) return dispatch({type: NOT_LOGGED_IN});

        dispatch({
          type: LOGIN_SUCCESS,
          payload: resp
        });

      })
  }
}

export function sessionExpired() {
  return {
    type: SESSION_EXPIRED
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/auth-actions.js